module.exports = __webpack_public_path__ + "static/media/Bastiodon_gaussian2.873285a4.png";